<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <v-btn
        fab
        absolute
        bottom
        right
        style="margin-bottom: 40px;"
        @click="isRegistered() ? unregister() : register()"
        v-on="on"
        :id="(isRegistered() ? 'event-register-' : 'event-unregister-') + event.id"
      >
        <v-icon :color="isRegistered() ? 'blue' : ''">{{ isRegistered() ? mdiBookCheck : mdiBookPlusOutline }}</v-icon>
      </v-btn>
    </template>
    <span>{{ $t(isRegistered() ? "PROGRAM.unfavorite_tooltip" : "PROGRAM.favorite_tooltip") }}</span>
  </v-tooltip>
</template>

<script>
  import { mdiBookCheck, mdiBookPlusOutline } from '@mdi/js';

  export default {
    name: 'RegisterButton',
    props: {
      event: {
        type: Object,
        required: true
      },
      user: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        mdiBookCheck,
        mdiBookPlusOutline
      }
    },
    methods: {
      isRegistered() {
        return Object.keys(this.user?.events || {}).includes(this.event.id);
      },
      register() {
        this.$emit('register');
      },
      unregister() {
        this.$emit('unregister');
      },      
    }
  }
</script>

<style scoped>
</style>